import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Defaults } from '@benefitsui/app/shared/defaults/defaults';
import { filter, map, Observable } from 'rxjs';
import { PageHeaderService, PageHeaderData } from '@benefitsui/app/services/page-header/page-header-service';
import { DocumentsClient } from '@benefitsui/app/api/benefits-clients';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: false
})
export class HomePageComponent implements OnInit, AfterViewInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public pageHeaderService: PageHeaderService,
    private cd: ChangeDetectorRef,
    private documentsClient: DocumentsClient
  ) {
    this.title$ = this.pageHeaderService.headerText$;
    this.headerData$ = this.pageHeaderService.headerData$;
  }

  groupName: string = Defaults.stringEmpty;
  groupNumber: string = Defaults.stringEmpty;
  title$: Observable<string>;
  headerData$: Observable<PageHeaderData>;
  hidePageHeader: boolean = false;

  ngOnInit(): void {
    const activatedRoute: ActivatedRoute | null = this.route;
    const policyInfo = activatedRoute && activatedRoute.snapshot.data['policyContext'];
    this.groupName = policyInfo.policyHolder || Defaults.stringEmpty;
    this.groupNumber = policyInfo.groupNumber || Defaults.stringEmpty;
    this.documentsClient.ffindex(policyInfo?.policyIds ?? []).subscribe({
      next: () => {
        console.log(`indexing complete`);
      },
      error: (err) => {
        console.log(`indexing failed: ${err}`);
      }
    });
    // Set header text based on navigation change.
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => activatedRoute),
        map((child) => {
          while (child.firstChild) {
            child = child.firstChild;
          }
          const title = child && child.snapshot.data['headerText'];
          const hidePageHeader = child && child.snapshot.data['hidePageHeader'];
          
          // Update hidePageHeader flag
          this.hidePageHeader = !!hidePageHeader;
          
          if (title) {
            return title;
          }
        })
      )
      .subscribe((title) => {
        this.pageHeaderService.setHeaderText(title ? title : Defaults.stringEmpty);
      });
  }

  ngAfterViewInit(): void {
    // Set header text on page load/reload.
    const child: ActivatedRoute | null = this.route.firstChild;
    const title = child && child.snapshot.data['headerText'];
    const hidePageHeader = child && child.snapshot.data['hidePageHeader'];
    
    // Update hidePageHeader flag
    this.hidePageHeader = !!hidePageHeader;
    
    this.pageHeaderService.setHeaderText(title ? title : Defaults.stringEmpty);
    this.cd.detectChanges();
  }
}
